<p-dialog
  header="Filtros do histórico de apontamentos"
  [visible]="visible"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '90vw', maxWidth: '560px' }"
  (onHide)="close()">
  <div class="v-form">
    <div class="v-form-row cols-1">
      <div class="v-field">
        <label for="tlh-users">Usuários <span class="tlh-required">*</span></label>
        <p-multiselect
          inputId="tlh-users"
          [options]="userOptions()"
          [ngModel]="userIds()"
          (ngModelChange)="userIds.set($event)"
          optionLabel="label"
          optionValue="value"
          placeholder="Selecione ao menos um usuário"
          display="chip"
          [filter]="true"
          [showToggleAll]="false"
          [loading]="usersLoading()"
          (onFilter)="onUserFilter($event)"
          filterPlaceHolder="Buscar usuário…"
          emptyFilterMessage="Nenhum usuário encontrado"
          [style]="{ width: '100%' }"
          appendTo="body" />
      </div>
    </div>

    <div class="v-form-row cols-1">
      <div class="v-field">
        <label for="tlh-customers">Clientes</label>
        <p-multiselect
          inputId="tlh-customers"
          [options]="customerOptions()"
          [ngModel]="customerIds()"
          (ngModelChange)="customerIds.set($event)"
          optionLabel="label"
          optionValue="value"
          placeholder="Todos os clientes"
          display="chip"
          [filter]="true"
          [showToggleAll]="false"
          [loading]="customersLoading()"
          (onFilter)="onCustomerFilter($event)"
          filterPlaceHolder="Digite 3 letras para buscar…"
          emptyFilterMessage="Digite ao menos 3 letras"
          [style]="{ width: '100%' }"
          appendTo="body" />
      </div>
    </div>

    <div class="v-form-row cols-2">
      <div class="v-field">
        <label for="tlh-date-from">Apontado de <span class="tlh-required">*</span></label>
        <p-datepicker
          inputId="tlh-date-from"
          [ngModel]="dateFrom()"
          (ngModelChange)="onDateChange('from', $event)"
          dateFormat="dd/mm/yy"
          placeholder="dd/mm/aaaa"
          [showIcon]="true"
          [style]="{ width: '100%' }"
          appendTo="body" />
        <!-- Semana de segunda a domingo, a mesma do atalho "Esta semana" desta tela. -->
        <app-quick-date-range
          [weekStartsOn]="1"
          [hasValue]="!!dateFrom() || !!dateTo()"
          (periodSelected)="onQuickPeriod($event)"
          (cleared)="onClearDates()" />
      </div>

      <div class="v-field">
        <label for="tlh-date-to">Apontado até <span class="tlh-required">*</span></label>
        <p-datepicker
          inputId="tlh-date-to"
          [ngModel]="dateTo()"
          (ngModelChange)="onDateChange('to', $event)"
          dateFormat="dd/mm/yy"
          placeholder="dd/mm/aaaa"
          [showIcon]="true"
          [style]="{ width: '100%' }"
          appendTo="body" />
      </div>
    </div>

    <!-- A regra "mexer nas datas fixa o período" é invisível sem isto, e este é
         exatamente o ponto onde ela é acionada. -->
    @if (periodoDinamicoAtivo()) {
      <p class="tlh-period-hint">
        <i class="pi pi-sync" aria-hidden="true"></i>
        <span>
          Período dinâmico: <strong>{{ periodoLabels[periodoRecebido()] }}</strong> — as datas
          acompanham a data de hoje a cada consulta. Alterá-las fixa o intervalo.
        </span>
      </p>
    }
  </div>

  <ng-template pTemplate="footer">
    <!-- A razão do bloqueio fica visível ao lado do botão: um botão apagado sem
         explicação é indistinguível de tela quebrada. -->
    @if (impedimento; as motivo) {
      <span class="tlh-blocker">
        <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
        {{ motivo }}
      </span>
    }

    <p-button
      label="Limpar cliente"
      icon="pi pi-filter-slash"
      severity="secondary"
      [outlined]="true"
      [disabled]="loading"
      (onClick)="onClear()" />

    @if (enableSavedFilters) {
      <p-button
        label="Salvar filtro"
        icon="pi pi-bookmark"
        severity="secondary"
        [text]="true"
        [disabled]="loading || !!impedimento"
        (onClick)="openSaveDialog()" />
    }

    <p-button
      label="Buscar"
      [icon]="loading ? 'pi pi-spin pi-spinner' : 'pi pi-search'"
      [loading]="loading"
      [disabled]="loading || !!impedimento"
      (onClick)="onSearch()" />
  </ng-template>
</p-dialog>

@if (enableSavedFilters) {
  <app-saved-filter-dialog
    [visible]="saveDialogVisible"
    (visibleChange)="onSaveDialogVisibleChange($event)"
    (save)="onSaveFilterConfirm($event)" />
}
